// #rollout — the managed delivery timeline (sign-off → live), from the proposal.
type RolloutStep = {
  week: string
  title: string
  description: string
}

const STEPS: RolloutStep[] = [
  {
    week: 'Week 1',
    title: 'Requirements & site survey',
    description: 'We review your gates, network, and enrollment, then confirm the right configuration for your campus.',
  },
  {
    week: 'Weeks 2–3',
    title: 'Procurement',
    description: 'Equipment and blank RFID cards are sourced and prepared for your school.',
  },
  {
    week: 'Weeks 4–5',
    title: 'Installation & setup',
    description: 'Readers and the central unit are installed on-site and the system is configured end to end.',
  },
  {
    week: 'Week 6',
    title: 'ID issuance & registration',
    description: "We photograph each student, capture their details and guardian's SMS number, and issue every RFID card.",
  },
  {
    week: 'Week 7',
    title: 'Testing, training & go-live',
    description: 'We test the full flow, train your staff, and hand over a running system.',
  },
]

export const RolloutSection = () => {
  return (
    <section className="section-custom bg-light bg-opacity-30 border-top border-bottom border-light" id="rollout">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold mb-2">Up and running in about 7 weeks</h2>
          <p className="text-muted mb-0">A clear, fully managed rollout — from sign-off to go-live.</p>
        </div>

        <div className="row g-4">
          {STEPS.map((step) => (
            <div className="col-md-6 col-xl" key={step.title}>
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <span className="badge text-bg-primary rounded-pill mb-3">{step.week}</span>
                  <h5 className="mb-2">{step.title}</h5>
                  <p className="text-muted small mb-0">{step.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
